<template>
  <div class="tourist">
    <div class="title">
      <h3 class="name">租客/客源</h3>
      <a-button type="primary" size="large" class="el_button el-button--primary" @click="GoAdd"> 新增客源 </a-button>
    </div>
    <div class="form">
      <div class="form-ipt">
        <input class="search-ipt" v-model="form.search" type="text" placeholder="智能搜索" @keyup.13="handleQuery" />
        <a-icon class="search" type="search" />
      </div>

      <a-form-model class="form-ant" ref="form" :model="form">
        <div class="col-one">
          <div>
            <a-form-model-item label="区域">
              <a-select
                mode="multiple"
                show-search
                option-filter-prop="children"
                @change="regionChange"
                v-model="form.districtIdList"
                placeholder="请选择"
              >
                <a-select-option :value="item.areaId" v-for="item in districtList" :key="item.areaId">
                  {{ item.areaName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>

          <div>
            <a-form-model-item label="商圈">
              <a-select placeholder="请选择" @change="businessDistrictMethod" v-model="form.businessDistrictId">
                <a-select-option :value="item.id" v-for="item in businessDistrict" :key="item.id">{{
                  item.businessDistrictName
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </div>

          <div>
            <a-form-model-item label="街道">
              <a-select placeholder="请选择" v-model="form.streetId">
                <a-select-option v-for="item in StreetData" :key="item.id" :value="item.id">{{
                  item.streetFullName
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </div>

          <div>
            <a-form-model-item label="状态">
              <a-select v-model="form.requirementStatus" placeholder="状态">
                <a-select-option value="1"> 有效 </a-select-option>
                <a-select-option value="6"> 草稿 </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
        </div>

        <div class="col-two">
          <div>
            <a-form-model-item label="可否餐饮">
              <a-select placeholder="可否餐饮" v-model="form.alloweCateringTypeId">
                <a-select-option :value="item.dictValue" v-for="item in foodCat" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <div>
            <a-form-model-item label="商铺类型">
              <a-select placeholder="请选择" v-model="form.shopType">
                <a-select-option :value="item.dictValue" v-for="item in typeOptions" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <div>
            <a-form-model-item label="维护人员">
              <div style="display: flex; align-items: center">
                <a-tree-select
                  v-model="form.deptId"
                  style="width: 150px"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :tree-data="deptOptions"
                  placeholder="部门"
                  :replaceFields="replaceFields"
                  tree-default-expand-all
                  @change="handleChangeTree"
                >
                </a-tree-select>
                <span>&nbsp;-&nbsp;</span>
                <a-select
                  v-model="form.accendantId"
                  @dropdownVisibleChange="handleOptiontourist($event)"
                  placeholder="人员"
                  style="width: 110px"
                >
                  <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
                    {{ item.nickName }}
                  </a-select-option>
                </a-select>
              </div>
            </a-form-model-item>
          </div>

          <div>
            <a-form-model-item label="行业分类">
              <span style="display: flex; margin-top: 4px">
                <a-select
                  style="margin-right: 3px"
                  v-model="form.industryCategoryId"
                  placeholder="行业大类"
                  @change="industrySubclassFn"
                >
                  <a-select-option v-for="item in industryCategory" :key="item.id" :value="item.id">{{
                    item.industryCategoryName
                  }}</a-select-option>
                </a-select>
                <span>-&nbsp;</span>
                <a-select v-model="form.industrySubclassId" placeholder="子类" style="width: 110px">
                  <a-select-option v-for="item in industrySubclass" :key="item.id" :value="item.id">{{
                    item.industryCategoryName
                  }}</a-select-option>
                </a-select>
              </span>
            </a-form-model-item>
          </div>
        </div>
        <div class="col-three">
          <span style="display: flex; align-items: center">
            <a-form-model-item label="面积" prop="requirementAreaStart">
              <a-input
                class="area-ipt"
                v-model="form.requirementAreaStart"
                :maxLength="5"
                type="text"
                placeholder="开始"
                @input="intValidate('requirementAreaStart')"
              />
            </a-form-model-item>
            <a-form-model-item class="form-lable" label=" " :colon="false">
              <span>-</span>
            </a-form-model-item>
            <a-form-model-item class="form-lable" label=" " :colon="false" prop="requirementAreaEnd">
              <a-input
                class="area-ipt"
                v-model="form.requirementAreaEnd"
                type="text"
                placeholder="结束"
                :maxLength="5"
                @input="intValidate('requirementAreaEnd')"
              />m²
            </a-form-model-item>
          </span>

          <span style="display: flex; align-items: center">
            <a-form-model-item label="租金" prop="rentExpenseStart">
              <a-input
                class="area-ipt"
                type="text"
                @change="timeSwitching"
                v-model="time.rentExpenseStart"
                placeholder="开始"
                :maxLength="7"
                @input="intValidate('rentExpenseStart')"
              />
            </a-form-model-item>
            <a-form-model-item class="form-lable" label=" " :colon="false">
              <span>-</span>
            </a-form-model-item>
            <a-form-model-item class="form-lable" label=" " :colon="false" prop="rentExpenseEnd">
              <a-input
                class="area-ipt"
                type="text"
                @change="timeSwitching"
                v-model="time.rentExpenseEnd"
                placeholder="结束"
                :maxLength="7"
                @input="intValidate('rentExpenseEnd')"
              /><span style="display: flex; width: 36px">{{ flag === 1 ? '元/月' : flag === 0 ? '元/日' : '' }}</span>
              <a-select placeholder="月租金" v-model="flag" style="width: 90px">
                <a-select-option :value="2"> 全部</a-select-option>
                <a-select-option :value="0"> 日租金</a-select-option>
                <a-select-option :value="1"> 月租金</a-select-option>
              </a-select>
            </a-form-model-item>
          </span>

          <span style="display: flex; align-items: center">
            <a-form-model-item label="楼层" prop="floorStart">
              <a-input
                v-model="form.floorStart"
                class="area-ipt"
                type="text"
                placeholder="开始"
                :maxLength="2"
                @input="intValidate('floorStart')"
              />
            </a-form-model-item>
            <a-form-model-item class="form-lable" label=" " :colon="false">
              <span>-</span>
            </a-form-model-item>
            <a-form-model-item class="form-lable" label=" " :colon="false" prop="floorEnd">
              <a-input
                v-model="form.floorEnd"
                class="area-ipt"
                type="text"
                placeholder="结束"
                :maxLength="2"
                @input="intValidate('floorEnd')"
              />层
            </a-form-model-item>
          </span>

          <div>
            <a-form-model-item style="margin-left: 40px">
              <div style="margin-top: 1px">
                <a-button class="el_button el_button_b" @click="handleReset"> 重置 </a-button>
                <a-button class="search-btn" @click="handleQuery" :style="{ marginLeft: '16px' }"> 查询 </a-button>
                <a-button type="primary" @click="export_touristList" style="margin-left: 20px">
                  <a-icon type="download" />导出
                </a-button>
              </div>
            </a-form-model-item>
          </div>
        </div>
        <div class="col-four">
          <div>
            <a-form-model-item label="日期">
              <a-select placeholder="全部" v-model="form.dateType">
                <a-select-option :value="0"> 全部</a-select-option>
                <a-select-option :value="1"> 跟进日期</a-select-option>
                <a-select-option :value="2"> 录入日期 </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <div>
            <a-form-model-item v-if="form.dateType" label="" style="display: flex; align-items: center">
              <div style="display: flex; align-items: center; width: 240px">
                <a-date-picker placeholder="开始时间" v-model="form.startTime" :disabled-date="disabledDate">
                </a-date-picker>
                <span>-</span>
                <a-date-picker placeholder="结束时间" v-model="form.endTime" :disabled-date="disabledDate">
                </a-date-picker>
              </div>
            </a-form-model-item>
            <a-form-model-item v-else label="" style="display: flex; align-items: center">
              <div style="width: 240px; opcity: 0">
                <span>&emsp;</span>
              </div>
            </a-form-model-item>
          </div>
        </div>
      </a-form-model>
    </div>
    <div class="table">
      <a-tabs type="card" :defaultActiveKey="activeNum" class="menu" @change="changeTabs">
        <a-tab-pane key="1" tab="全部客源">
          <div class="searchMenu">
            <div class="item-box">
              <div></div>
              <div></div>
              <div></div>
              <div style="display: flex; align-items: center; width: 122px">
                <span
                  style="margin-right: 5px; width: 66px; cursor: pointer"
                  :class="{ cur: this.curLook }"
                  @click="changeUpDown"
                >带看</span
                >
                <a-select style="width: 100%" placeholder="全部" @change="dateListChange">
                  <a-select-option :value="item" v-for="item in dateList" :key="item">{{ item }} </a-select-option>
                </a-select>
                <div class="icons" @click="changeUpDown">
                  <a-icon type="caret-up" :class="{ cur: this.curLook && this.form.sortType == 'ASC' }" />
                  <a-icon type="caret-down" :class="{ cur: this.curLook && this.form.sortType == 'DESC' }" />
                </div>
              </div>
            </div>
          </div>

          <tourist-list :DataList="DataList" :dishTypeOpts="dishTypeOpts"></tourist-list>
        </a-tab-pane>
        <a-tab-pane key="2" tab="我的客源" style="padding-top: 42px">
          <tourist-list :DataList="DataList" :dishTypeOpts="dishTypeOpts"></tourist-list>
        </a-tab-pane>
        <a-tab-pane key="3" tab="小组客源" v-if="$getters.userInfo.position === 2" style="padding-top: 42px">
          <tourist-list :DataList="DataList" :dishTypeOpts="dishTypeOpts"></tourist-list>
        </a-tab-pane>
        <a-tab-pane key="4" tab="门店公盘" style="padding-top: 42px">
          <tourist-list :DataList="DataList" :dishTypeOpts="dishTypeOpts"></tourist-list>
        </a-tab-pane>
        <a-tab-pane key="5" tab="公司公盘" style="padding-top: 42px">
          <tourist-list :DataList="DataList" :dishTypeOpts="dishTypeOpts"></tourist-list>
        </a-tab-pane>
        <a-tab-pane key="6" tab="即将掉盘" style="padding-top: 42px">
          <tourist-list :DataList="DataList" :dishTypeOpts="dishTypeOpts"></tourist-list>
        </a-tab-pane>
        <a-tab-pane key="7" tab="草稿" style="padding-top: 42px">
          <tourist-list :DataList="DataList" :dishTypeOpts="dishTypeOpts"></tourist-list>
        </a-tab-pane>
      </a-tabs>
      <!-- 分页 -->
      <a-pagination
        class="pagination"
        show-size-changer
        :pageSizeOptions="pagination.pageSizeOptions"
        :pageSize="pageSize"
        :current="pageNum"
        :total="total"
        v-if="total"
        :showTotal="(total) => `共 ${total} 条`"
        @change="pageChange"
      />
      <no-data v-else></no-data>
    </div>

    <div class="topcenter" v-show="listLoding">
      <LoadingModel></LoadingModel>
    </div>
  </div>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import {
  getYMDHMS,
  getBeginToday,
  getCurrentDate,
  getBeginYesterday,
  getEndYesterday,
  getBeginWeek,
  getEndWeek,
  getBeginLastWeek,
  getEndLastWeek,
  getBeginMonth,
  getEndMonth,
  getBeginLastMonth,
  getEndLastMonth
} from '@/utils/date'
import moment from 'moment'
import touristList from '../modules/cards/touristList.vue'
import LoadingModel from '@/components/Loading'
import { treeSelectMixin } from '@/mixin/treeSelect'
import { locationSelectMixin } from '@/mixin/locationSelect'

export default {
  components: { touristList, LoadingModel },
  mixins: [treeSelectMixin, locationSelectMixin],

  data () {
    // 数字正则
    const validateNumber = (rule, value, callback) => {
      const reg = /^\+?[1-9][0-9]*$/
      if (value === '') {
        callback()
      } else if (!reg.test(value)) {
        callback(0)
      } else {
        callback()
      }
    }
    return {
      industryCategory: [],
      industrySubclass: [],
      pagination: {
        pageSizeOptions: ['10', '20', '30']
      },
      form: {
        requirementResourceType: 1, // 1:全部房源 2：我的客源 3：小组客源 4：门店客源 5：公客 6：即将掉盘
        requirementSort: 1, // 房源排序（1：默认 2：带看 ）
        sortType: 'ASC', // 排序规则 ASC / DESC
        accendantId: undefined, // 部门人员ID
        alloweCateringTypeId: undefined,
        dateType: undefined, // 日期类型(1：跟进、2：录入)
        deptId: undefined, // 部门ID
        districtId: undefined,
        businessDistrictId: undefined,
        streetId: undefined,
        startTime: '',
        endTime: '',
        floorEnd: '',
        floorStart: '',
        isAsc: '',
        isCatering: undefined,
        orderByColumn: '',
        rentExpenseEnd: '',
        rentExpenseStart: '',
        requirementAreaEnd: '',
        requirementAreaStart: '',
        requirementStatus: undefined, // 客源需求状态
        search: '',
        shopType: undefined, // 商铺类型ID
        industryCategoryId: undefined, // 行业大类
        industrySubclassId: undefined, // 行业子类

        // 多选
        districtIdList: [],
        businessDistrictIdList: [],
        alloweCateringTypeIdList: [],
        streetIdList: []
      },
      time: {
        rentExpenseStart: '',
        rentExpenseEnd: ''
      },
      vForm: {
        districtVal: undefined,
        businessVal: undefined
      },
      listLoding: false,
      flag: 1,
      DataList: [], // 数据列表
      // districtList: [], // 区域列表
      businessDistrict: [], // 商圈
      StreetData: [], // 街道
      query: {},
      // rules: {
      //   requirementAreaStart: [{ validator: validateNumber, trigger: 'blur' }],
      //   requirementAreaEnd: [{ validator: validateNumber, trigger: 'blur' }],
      //   rentExpenseStart: [{ validator: validateNumber, trigger: 'blur' }],
      //   rentExpenseEnd: [{ validator: validateNumber, trigger: 'blur' }],
      //   floorStart: [{ validator: validateNumber, trigger: 'blur' }],
      //   floorEnd: [{ validator: validateNumber, trigger: 'blur' }],
      // },
      // 分页数据
      total: 0, // 总条数
      pageNum: 1, // 当前页
      pageSize: 10, // 页条数

      // 数据字典
      isOptions: [], // 餐饮类型
      foodCat: [],
      typeOptions: [],
      dishTypeOpts: [],

      // 日期时间筛选
      dateList: ['今日', '昨天', '本周', '上周', '本月', '上月', '全部'],
      // 部门人员
      dept: [],
      userList: [],
      activeNum: '1',
      curLook: false // 带看激活标识
    }
  },
  methods: {
    // 导出-客源信息查询列表
    export_touristList () {
      if (this.form.startTime) {
        this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD')
      }
      if (this.form.endTime) {
        this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD')
      }
      if (this.form.dateType === 0) {
        this.form.dateType = ''
      }

      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据',
        onOk () {
          that.downloadPost(
            '/lesseeRequirement/export',
            {
              ...that.form
            },
            `p_${new Date().getTime()}.xls`
          )
        },
        onCancel () {}
      })
    },
    // 获取行业分类（行业小类）
    industrySubclassFn (val) {
      const params = {
        industryCategoryType: 2, // 行业类型（1：行业分类（行业大类） 2：经营行业（行业小类））
        parentId: val
      }
      touristApi.industryCategory(params).then((res) => {
        if (res.code == 200) {
          this.industrySubclass = res.data
        }
      })
    },

    // 获取行业分类（行业大类）
    industryCategoryFn () {
      const params = {
        industryCategoryType: 1 // 行业类型（1：行业分类（行业大类） 2：经营行业（行业小类））
      }
      touristApi.industryCategory(params).then((res) => {
        if (res.code == 200) {
          this.industryCategory = res.data
        }
      })
    },
    // 是否首页进入-即将掉盘
    dataList () {
      if (this.$route.query.str) {
        this.activeNum = '6'
        this.changeTabs(6)
      } else {
        this.activeNum = '1'
        this.getDataList()
      }
    },
    // 获取列表数据
    async getDataList () {
      this.listLoding = true
      const res = await touristApi.lesseeRequirementList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.form
      })
      this.listLoding = false
      this.total = res.data.total
      this.DataList = res.data.records
    },

    // 清空表单按钮
    handleReset () {
      this.form.alloweCateringTypeId = undefined
      this.form.requirementAreaStart = ''
      this.form.requirementAreaEnd = ''
      this.form.isCatering = undefined
      this.form.floorStart = ''
      this.form.floorEnd = ''
      this.form.streetName = ''
      this.form.streetId = undefined
      this.form.search = ''
      this.form.districtId = undefined
      this.form.businessDistrictId = undefined
      this.form.rentExpenseStart = ''
      this.form.rentExpenseEnd = ''
      this.form.shopType = undefined // 商铺类型ID
      this.form.accendantId = undefined // 部门人员ID
      this.form.deptId = undefined // 部门ID
      this.form.dateType = undefined
      this.form.startTime = undefined
      this.form.endTime = undefined
      this.form.requirementStatus = undefined
      this.form.industryCategoryId = undefined
      this.form.industrySubclassId = undefined
      this.industrySubclass = []
      this.time = {
        rentExpenseStart: '',
        rentExpenseEnd: ''
      }

       // 多选
      this.form.districtIdList = []
      this.form.businessDistrictIdList = []
      this.form.alloweCateringTypeIdList = []
      this.form.streetIdList = []

      this.businessDistrict = [] // 商圈
      this.StreetData = [] // 街道
      this.getDistrict()
      this.userList = []
      this.getDeptList()
      this.getDataList() // 查询列表
      this.curLook = false
      this.flag = 1
    },
    // 查询表单按钮
    handleQuery () {
      if (this.form.startTime) {
        this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD')
      }
      if (this.form.endTime) {
        this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD')
      }
      if (this.form.dateType === 0) {
        this.form.dateType = ''
      }
      this.getDataList()
    },
    disabledDate (current) {
      return current && current > moment().endOf('day')
    },

    // 跳转新增客源页面
    GoAdd () {
      this.$router.push('/tourist/add')
    },

    // 获取街道列表
    businessDistrictMethod (val) {
      this.form.streetId = undefined
      const params = {
        businessDistrictId: val,
        streetFullName: '',
        streetShortName: ''
      }
      touristApi.GetStreetList(params).then((res) => {
        if (res.code == 200) {
          this.StreetData = res.data
        }
      })
    },

    // 获取部门列表
    getDeptList () {
      touristApi.getDeptList().then((res) => {
        if (res.code == 200) {
          this.dept = res.data.map((item) => {
            return {
              deptId: item.deptId,
              deptName: item.deptName
            }
          })
        }
      })
    },

    // 获取部门人员列表
    chooseDept (val) {
      this.form.accendantId = undefined
      touristApi.getUserList({ deptId: val }).then((res) => {
        if (res.code == 200) {
          this.userList = res.rows
        }
      })
    },

    // 租金范围
    timeSwitching () {
      if (this.flag === 1) {
        this.form.rentExpenseStart = this.time.rentExpenseStart
        this.form.rentExpenseEnd = this.time.rentExpenseEnd
      } else if (this.flag === 0) {
        this.form.rentExpenseStart = this.time.rentExpenseStart * 30
        this.form.rentExpenseEnd = this.time.rentExpenseEnd * 30
      } else {
        this.form.rentExpenseStart = ''
        this.form.rentExpenseEnd = ''
        this.time.rentExpenseStart = ''
        this.time.rentExpenseEnd = ''
      }
    },

    // 切换选项卡
    changeTabs (key) {
      this.form.requirementResourceType = Number(key)
      this.getDataList()
    },

    // 切换分页
    pageChange (page, pageSize) {
      this.pageNum = page
      this.pageSize = pageSize
      this.getDataList()
    },

    // 默认，带看切换
    changeUpDown () {
      this.curLook = true
      this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
      this.form.requirementSort = 2
      this.getDataList()
    },

    // 时间下拉框
    dateListChange (val) {
      this.form.startTime =
        val === '今日'
          ? getYMDHMS('/', ':', getBeginToday())
          : val === '昨天'
          ? getYMDHMS('/', ':', getBeginYesterday())
          : val === '本周'
          ? getYMDHMS('/', ':', getBeginWeek())
          : val === '上周'
          ? getYMDHMS('/', ':', getBeginLastWeek())
          : val === '本月'
          ? getYMDHMS('/', ':', getBeginMonth())
          : val === '上月'
          ? getYMDHMS('/', ':', getBeginLastMonth())
          : ''
      this.form.endTime =
        val === '今日'
          ? getYMDHMS('/', ':', getCurrentDate())
          : val === '昨天'
          ? getYMDHMS('/', ':', getEndYesterday())
          : val === '本周'
          ? getYMDHMS('/', ':', getEndWeek())
          : val === '上周'
          ? getYMDHMS('/', ':', getEndLastWeek())
          : val === '本月'
          ? getYMDHMS('/', ':', getEndMonth())
          : val === '上月'
          ? getYMDHMS('/', ':', getEndLastMonth())
          : ''
      this.form.requirementSort = 2
      this.getDataList()
    },

    // int验证
    intValidate (fieldName) {
      const val =
        fieldName === 'rentExpenseStart' || fieldName === 'rentExpenseEnd' ? this.time[fieldName] : this.form[fieldName]
      const reg = /^[0-9]{1,6}$/
      if (!reg.test(val)) {
        if (fieldName === 'rentExpenseStart' || fieldName === 'rentExpenseEnd') {
          this.time[fieldName] = ''
        } else {
          this.form[fieldName] = ''
        }
      }
    }
  },
  created () {
    // 获取数据列表
    this.dataList()

    // 获取部门列表
    this.getDeptList()
    this.industryCategoryFn()

    // 字典列表
    this.getDicts('house_status').then((response) => {
      this.isOptions = response.data
      console.log(response.data, 'house_status')
    })
    this.getDicts('shop_type').then((response) => {
      this.typeOptions = response.data
      // console.log('shop_type', this.typeOptions)
    })
    // 盘别
    this.getDicts('dish_type').then((response) => {
      this.dishTypeOpts = response.data
      // console.log(this.dishTypeOpts, 'dish_type')
    })
    // 餐饮类型
    this.getDicts('repast_type').then((response) => {
      this.foodCat = response.data
      // console.log('repast_type', this.food)
    })
  },

  mounted () {
  },

  watch: {
    // 监听客户是否点击切换租金单位
    flag () {
      if (this.flag === 1) {
        this.time.rentExpenseStart = this.form.rentExpenseStart
        this.time.rentExpenseEnd = this.form.rentExpenseEnd
      } else if (this.flag === 0) {
        this.time.rentExpenseStart = this.form.rentExpenseStart
          ? (this.form.rentExpenseStart / 30).toFixed(2)
          : this.time.rentExpenseStart
        this.time.rentExpenseEnd = this.form.rentExpenseEnd
          ? (this.form.rentExpenseEnd / 30).toFixed(2)
          : this.time.rentExpenseEnd
      } else {
        this.time.rentExpenseStart = ''
        this.time.rentExpenseEnd = ''
        this.form.rentExpenseStart = ''
        this.form.rentExpenseEnd = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.tourist {
  height: 100%;
  .title {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    background-color: white;

    .name {
      font-size: 20px;
      font-weight: bold;
      color: #000;
    }

    button {
      background-color: var(--ThemeColor);
      font-size: 14px;
      width: 100px;
      height: 40px;
      border: none;
    }
  }
  .form {
    padding: 0 20px;
    background-color: white;

    .form-ipt {
      position: relative;
      margin-bottom: 20px;
      .search-ipt {
        // width: 50%;
        height: 36px;
        border-radius: 20px;
        outline: none;
        border: 1px solid rgb(236, 236, 236);
        padding-left: 50px;
        width: 300px;
        border-radius: 30px;
      }
      .search {
        font-size: 22px;
        position: absolute;
        left: 20px;
        top: 10px;
      }
    }
    .form-ant {
      display: flex;
      justify-content: space-between;
      .col-two {
        .form-lable {
          /deep/.ant-form-item-label {
            width: 0px;
          }
        }
      }
      .area-ipt {
        width: 80px;
      }
      .floor-ipt {
        width: 60px;
      }
      .ant-form-item {
        display: flex;
        align-items: center;
        /deep/.ant-form-item-children {
          display: flex;
          align-items: center;
        }

        .rzj {
          width: 60px;
          display: inline-block;
          background-color: #c0c0c0;
          height: 20px;
          line-height: 20px;
          font-size: 6px;
          padding-left: 5px;
          padding-right: 5px;
          text-align: center;
          cursor: pointer;
        }

        .isflag {
          border: 1px solid var(--ThemeColor);
          color: var(--ThemeColor);
          background-color: #fef7f1;
        }
        .el_button_b {
          width: 62px;
        }
        .search-btn {
          background-color: var(--ThemeColor);
          color: white;
        }
      }
      .flex {
        display: flex;
        align-items: center;
        line-height: 26px;
      }
      /deep/.ant-select {
        width: 150px;
      }
    }
  }
  .table {
    margin-top: 10px;
    padding-bottom: 50px;
    background-color: white;

    .menu {
      padding-top: 20px;
      .searchMenu {
        margin-top: 10px;
        .item-box {
          display: flex;
          margin-left: 160px;
          & > div {
            width: 17%;
          }
        }
        /deep/.ant-select-selection {
          width: 75px;
        }
        .cur {
          color: var(--ThemeColor);
        }
      }
      /deep/.ant-tabs-nav-scroll {
        height: 37px;
      }
      /deep/.ant-tabs-nav-container {
        margin-left: -20px;
        margin-bottom: -3px;
      }

      /deep/ .ant-tabs-bar {
        border-bottom: 3px solid var(--ThemeColor);
        padding-left: 20px;
        width: 98%;
        margin: 0 auto;
      }
      /deep/.ant-tabs-content {
        padding-left: 10px;
      }

      /deep/.ant-tabs-tab {
        margin-right: 0px;
        border: none;
        background-color: #ffffff;
      }
      /deep/ .ant-tabs-tab-active {
        background-color: var(--ThemeColor);
        color: #fff;
        border-radius: 5px;
      }

      .icons {
        display: flex;
        flex-wrap: wrap;
        width: 20px;
        height: 25px;
        cursor: pointer;
      }
    }
    .pagination {
      float: right;
      margin-right: 20px;
    }
  }
  .topcenter {
    position: fixed;
    top: 43%;
    left: 50%;
  }
}
</style>
